(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const AUTOPLAY_MS = 5000;

  function getCarouselSlides(frame) {
    return [...frame.querySelectorAll('[data-pokespott-hero-slide]')].filter((slide) => {
      if (!DESKTOP_MQ.matches && slide.classList.contains('hero__pokespott-slide--desktop-only')) {
        return false;
      }
      return true;
    });
  }

  function initFrame(frame) {
    let index = 0;
    let timer = null;

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!DESKTOP_MQ.matches || REDUCED_MOTION.matches) return;
      if (getCarouselSlides(frame).length < 2) return;
      timer = setInterval(() => step(1), AUTOPLAY_MS);
    };

    const sync = () => {
      const slides = getCarouselSlides(frame);

      if (slides.length < 2) {
        slides.forEach((slide) => {
          slide.hidden = false;
          slide.classList.add('is-active');
        });
        stopAutoplay();
        return;
      }

      if (index >= slides.length) index = 0;

      frame.querySelectorAll('[data-pokespott-hero-slide]').forEach((slide) => {
        slide.classList.remove('is-active');
        slide.hidden = !slides.includes(slide);
      });

      slides[index]?.classList.add('is-active');
      slides[index].hidden = false;
    };

    const step = (direction) => {
      const slides = getCarouselSlides(frame);
      if (slides.length < 2) return;
      index = (index + direction + slides.length) % slides.length;
      sync();
      startAutoplay();
    };

    frame.addEventListener('mouseenter', stopAutoplay);
    frame.addEventListener('mouseleave', startAutoplay);
    frame.addEventListener('focusin', stopAutoplay);
    frame.addEventListener('focusout', (event) => {
      if (frame.contains(event.relatedTarget)) return;
      startAutoplay();
    });

    DESKTOP_MQ.addEventListener('change', () => {
      index = 0;
      sync();
      startAutoplay();
    });

    REDUCED_MOTION.addEventListener('change', () => {
      if (REDUCED_MOTION.matches) stopAutoplay();
      else startAutoplay();
    });

    sync();
    startAutoplay();
  }

  function init() {
    document.querySelectorAll('[data-pokespott-hero-carousel]').forEach(initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
